import "babel-polyfill";
import Vue from "vue";
import "./plugins/axios";
import "./plugins/vuetify";
import "./plugins/filter";
import App from "./App.vue";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import router from "./router";
import store from "./store/index";
import VeeValidate from "vee-validate";
import Meta from "vue-meta";
import VueCookies from 'vue-cookies';
Vue.config.productionTip = false;

Vue.use(VueCookies);
VueCookies.config('7d');

Vue.use(VeeValidate, { inject: false });
Vue.use(Meta);
// Vue.use(VueLazyLoad);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
